import React, { useEffect, useState } from 'react';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import PrimaryButton from '../../Form/PrimaryButton';
import Modal from '../Modal';
import styles from './PasswordAuthInductionModal.module.css';

function PasswordAuthInductionModal(props) {
  const {
    firebaseUser,
    proceedIdPage,
    accountIntegrationInductionModal,
    doctorAuthenticationInductionModal,
  } = props;
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [currentProvider, setCurrentProvider] = useState('');

  useEffect(() => {
    if (!isOpenModal) return;
    sendAnalyticsEvent('password_auth_induction', 'show', null);
  }, [isOpenModal]);

  /**
   * 認証状況に応じて表示画面を切り替え
   */
  useEffect(() => {
    (async () => {
      if (firebaseUser) {
        const hasPasswordAuth = firebaseUser.providerData.some(
          (v) => v.providerId === 'password',
        );
        if (hasPasswordAuth) {
          // 認証方法変更が必要な場合
          if (firebaseUser.providerData.length >= 2) {
            if (firebaseUser.emailVerified) {
              // パスワード認証設定済みで、他の認証方法が未削除の場合はログイン方法変更完了画面を表示
              proceedIdPage(
                '/users/change-login-method-completed?from_service=qa',
              );
            } else {
              // メールアドレス確認画面を表示
              proceedIdPage(
                '/users/change-login-method-verify-email?from_service=qa',
              );
            }
          }
        } else {
          const providerId = firebaseUser.providerData[0]?.providerId ?? '';
          setCurrentProvider(
            providerId === 'facebook.com'
              ? 'facebook'
              : providerId === 'apple.com'
              ? 'apple'
              : '',
          );
          setIsOpenModal(true);
        }
      }
    })();
  }, [firebaseUser, proceedIdPage]);

  const onProceed = () => {
    sendAnalyticsEvent('password_auth_induction', 'click', 'proceed');

    try {
      setIsOpenModal(false);
      proceedIdPage(
        `/users/change-login-method?current_provider=${currentProvider}&from_service=qa`,
      );
    } catch (e) {
      console.error(e);
    }
  };

  const onProceedCancel = () => {
    sendAnalyticsEvent('password_auth_induction', 'click', 'close');
    setIsOpenModal(false);
  };

  // アカウント統合モーダル、医師認証モーダル表示中は表示しない
  if (
    accountIntegrationInductionModal.show ||
    doctorAuthenticationInductionModal.show ||
    !isOpenModal
  ) {
    return null;
  }
  return (
    <Modal
      close={onProceedCancel}
      confirm={true}
      style={{ borderRadius: '20px' }}
    >
      <div className={styles.modal}>
        <div className={styles.modalHeading}>
          <img src="/images/antaa_logo_only.png" alt="logo" width="50%" />
          <p className={styles.heading}>ログイン変更のお願い</p>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.content}>
            <p>
              セキュリティ強化および個人情報保護対策の一環としてFacebookおよびApple
              IDによるログインを廃止させていただくことになりました。誠に恐れ入りますが、メールアドレスによるログインへの変更をお願い致します。
            </p>
            <p>
              2026年1月26日以降、Facebookによるログインが出来なくなる可能性があります。
              <b>
                <u>
                  Facebookログインをご利用の方は早めの移行をお願い致します。
                </u>
              </b>
            </p>
          </div>

          <div className={styles.actions}>
            <PrimaryButton
              style={{
                width: '100%',
                borderRadius: '20px',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
              value={'メールログインに切り替える'}
              theme={'submit'}
              onClick={onProceed}
            />
            <div className={styles.closeText} onClick={onProceedCancel}>
              あとで行う
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default PasswordAuthInductionModal;
